import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellularAlt1BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_alt_1_bar"}/>
}
